import '../views/statements/overview.html'
import { accounts, accountsDetails, statements } from '../services/arsweb/RoutingPaths';
import { DetailViewController } from './DetailViewController';
import { CONSOLIDATION_CURRENCY } from '../components/tables/accounts/accountsView.directive';
import { DEF_CURRENCY } from "../views/dashboard/dashboard";
import { REACT_AH_CRUMBS_DETAIL_DATA_READY } from "../components/react/AwApplicationHeaderHelpers/AwApplicationHeaderHelpers";
import { CONSOLIDATION_CURRENCY_PARAMS } from './CommonViewController';

export const STATEMENT_DETAIL_ROUTE = 'app.statementDetail';

export class StatementController extends DetailViewController {

    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);
        this.userService = userService;
        this.filterFormatter = userService.filterFormatter;
        this.initDateRange();
    }

    initSessionPersistanceDependencies($stateParams) {
        //init consolidation currency
        this.$scope.consolitationcurrency = this.sessionPersistance.get(CONSOLIDATION_CURRENCY) || DEF_CURRENCY;
        this.sessionPersistance.set(CONSOLIDATION_CURRENCY, this.$scope.consolitationcurrency);
        if ($stateParams.id && $stateParams.parentID) {
            this.$scope.accountID = $stateParams.parentID;
            this.statementID = $stateParams.id;
            this.$scope.detailPromise = this.loadStatement();
        }
    }

    loadStatement() {
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.consolitationcurrency.code;
        return this.accountService.getUserData(accounts + statements + "/" + this.statementID).then((data) => {
            this.$scope.statementInfo = data;
            this.$scope.accountInfo = data.account;
            this.fractionDigits = this.$scope.accountInfo.balance.fractionDigits;

            this.$scope.$emit(REACT_AH_CRUMBS_DETAIL_DATA_READY, this.$scope.accountInfo);

            this.userService.promise.then(() => {
                this.$scope.statementInfo.openingBalanceFormatted =
                    this.filterFormatter('fsNumber')(this.$scope.statementInfo.openingBalance, this.$scope.accountInfo.balance.fractionDigits);
                this.$scope.statementInfo.closingBalanceFormatted =
                    this.filterFormatter('fsNumber')(this.$scope.statementInfo.closingBalance, this.$scope.accountInfo.balance.fractionDigits);
                this.$scope.statementInfo.openingDateFormatted = this.filterFormatter('fsDateNoLocal')(this.$scope.statementInfo.openingDate);
                this.$scope.statementInfo.closingDateFormatted = this.filterFormatter('fsDateNoLocal')(this.$scope.statementInfo.closingDate);
                const endNinthCenYear = 1899;
                if(new Date(this.$scope.statementInfo.closingAvailableDate).getFullYear() !== endNinthCenYear) {
                    this.$scope.statementInfo.closingAvailableDateFormatted =
                        this.filterFormatter('fsDateNoLocal')(this.$scope.statementInfo.closingAvailableDate);
                    this.$scope.statementInfo.closingAvailableBalanceFormatted =
                        this.filterFormatter('fsNumber')(this.$scope.statementInfo.closingAvailableBalance, this.$scope.accountInfo.balance.fractionDigits);
                }
            });
        });
    }

    loadAccount(pickedDate) {
        this.$scope.consolitationcurrency = this.sessionPersistance.get(CONSOLIDATION_CURRENCY);
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.consolitationcurrency.code;
        this.accountService.service.config.params['id'] = this.$scope.accountID;
        this.accountService.service.config.params['endDate'] = pickedDate.valueOf();
        return this.accountService.getUserData(accountsDetails).then(data => {
            this.$scope.accountInfo = data;
            this.$scope.statementInfo.account = data;
        });
    }
}
